// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CreateCashAdvanceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Payroll_CashAdvanceDespesaRow } from './Payroll_CashAdvanceDespesaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CreateCashAdvanceResponseDados {
success: boolean
advance_id: number
despesa: Payroll_CashAdvanceDespesaRow
error: string
}

export type Payroll_CreateCashAdvanceResponse = ApiResponse<Payroll_CreateCashAdvanceResponseDados>;

registerResponseContract('Payroll_CreateCashAdvanceResponse', {
  success:    { type: 'boolean', required: true },
  advance_id: { type: 'number',  required: false },
  despesa: {
    type: 'object',
    required: false,
    fields: {
      id:             { type: 'number',  required: true },
      despesa_valor:  { type: 'number',  required: true },
      despesa_status: { type: 'number',  required: true },
    },
  },
  error:      { type: 'string',  required: false },
})
